import React from 'react';
import { writeErrorLog } from '../api/activityLog';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
componentDidCatch(error, info) {
  writeErrorLog({
    orgId: this.props.orgId || null,
    userId: this.props.userId || null,
    userName: this.props.userName || null,
    error,
    context: {
      componentStack: info.componentStack,
      url: window.location.href,
      path: window.location.pathname,
    },
  });
}

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>The error has been logged. Please refresh the page.</p>
          <button onClick={() => this.setState({ hasError: false, error: null })}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;